import { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DatePicker, DatePickerProps } from '../../UI';
import { PersonFormValues } from '../types';

interface PersonDateOfBirthDatePickerProps
  extends Pick<DatePickerProps, 'withIcon' | 'label' | 'placement' | 'className'> {
  required?: boolean;
}

export const PersonDateOfBirthDatePicker: FC<PersonDateOfBirthDatePickerProps> = ({
  label,
  required,
  ...datePickerProps
}) => {
  const { control } = useFormContext<PersonFormValues>();
  const { t: tForm } = useTranslation('form');
  const {
    field,
    formState: { errors },
  } = useController<PersonFormValues, 'dateOfBirth'>({
    control,
    name: 'dateOfBirth',
    rules: {
      required: required,
      validate: (value) => {
        if (!value && required) return 'This field is required';
        return true;
      },
    },
  });

  return (
    <DatePicker
      {...field}
      {...datePickerProps}
      status={errors.dateOfBirth ? 'errored' : 'normal'}
      label={label ?? tForm('general-dob-date-picker-label')}
      placeholder={required ? tForm('general-required-placeholder') : undefined}
      offsetYears={-20}
    />
  );
};
